import { useEffect } from "react";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { CrashPage } from "components/errors/CrashPage";
import { logError } from "shared/services/ErrorReporting";

/**
 * What a route shows when its component throws (Jira NAV-169).
 *
 * **The router catches first.** Every route renders inside TanStack's own
 * boundary, so a throw from a page's render or effect never reaches the app's
 * `ErrorBoundary` in `App.tsx`, whose `onError` is where `logError` is wired.
 * Without this, the router's built-in default takes it: the raw message under
 * "Something went wrong!", reported nowhere.
 *
 * Rendered in place of the failing route only, so the shell around it (the
 * navigation bar, the admin rail) stays usable and the reader can leave for a
 * page that works — which is why this one offers the way back.
 */
export function RouteErrorScreen({ error }: ErrorComponentProps) {
  useEffect(() => {
    logError(error);
  }, [error]);

  return <CrashPage error={error} offerBack />;
}
